import * as React from 'react'
import DOMPurify from 'dompurify'
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  CardActionArea,
} from '@material-ui/core'
import DateRangeIconAndDate from '../CommuterResources/components/CReventCard/DateRangeIconAndDate'
// import DateRangeIconAndDate from './DateRangeIconAndDate'
import {
  isoStringConverter,
  eventLength,
  formatOngoingEventDate,
} from '../CommuterResources/components/CReventCard/helpers/eventHelpers'

// import OngoingeventBadge from './OngoingeventBadge'
// import EventLocationAndVenueDisplay from './EventLocationAndVenueDisplay'

const SWeventCard = ({ classes, handleClick, data }) => {
  const startDate = isoStringConverter(data.utc_start_date)
  const endDate = isoStringConverter(data.utc_end_date, false, true)
  const ongoingEvent = eventLength(data.utc_start_date, data.utc_end_date)
  const ongoingEventDate = formatOngoingEventDate(
    data.utc_start_date,
    data.utc_end_date,
  )

  return (
    <Card
      className={classes.eventCard}
      variant="outlined"
      aria-label={data.location_name}
      key={data.id}
    >
      <CardActionArea
        onClick={() => handleClick(data.url, data.title)}
        className={classes.eventCardActionArea}
      >
        <CardMedia
          image={data.image?.url}
          alt={`${data.title} event image`}
          className={classes.eventCardImage}
        />
        <CardContent className={classes.eventCardContent}>
          <Typography variant="h3" className={classes.eventCardTitle}>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(data.title),
              }}
            />
          </Typography>
          <DateRangeIconAndDate
            classes={classes}
            eventSatus={data.state_status}
            startDate={startDate}
            endDate={endDate}
            isOngoing={ongoingEvent}
            ongoingEventDate={ongoingEventDate}
            eventState={data.state_status}
          />
          {/* <OngoingeventBadge isOngoing={ongoingEvent} /> */}
        </CardContent>
      </CardActionArea>
      {/* <CardActions className={classes.eventCardActions}>
        <EventLocationAndVenueDisplay
          classes={classes}
          onlineURL={data.address_onlineLocation}
          venue={data.venue_venue}
          venueGeoLat={data.address_latitude}
          venueGeoLng={data.address_longitude}
          addressName={data.address_name}
          props={data}
        />
      </CardActions> */}
    </Card>
  )
}

export default SWeventCard
